import React from 'react';
import Route from 'app/components/RouteInterceptor.tsx';
import { LOGIN, OTP } from 'app/constants/Routes';
import * as RouterUtils from 'app/utils/RouterUtils.js';

import { Redirect as RouterRedirect } from 'react-router-dom';

const Redirect = ({ to, ...rest }) => {
    if (to && ((to.pathname && to.pathname.startsWith('/')) || to.startsWith('/'))) {
        return <RouterRedirect to={to} {...rest} />;
    }
    window.location = to;
    return null;
};

const PrivateRoute = ({ component: Content, authed, ...rest }) => (
    <Route
        {...rest}
        render={() => {
            // const {
            //     match: { path },
            //     location,
            // } = props;
            // if (!authed.accessToken) {
            //     const pathName = RouterUtils.locationToUrl(location, '/');
            //     const nextUrl = `${window.location.origin}${pathName === '/404' || pathName === '/logout-all-devices' ? '/' : pathName}`;
            //     const loginUrl = `${LOGIN}?nexturl=${encodeURIComponent(nextUrl)}`;
            //     return <Redirect to={loginUrl} />;
            // }
            // if (!authed.mfaToken && path !== OTP) {
            //     const pathName = RouterUtils.locationToUrl(location, '/');
            //     const nextUrl = `${window.location.origin}${pathName === '/404' || pathName === '/logout-all-devices' ? '/' : pathName}`;
            //     const otpUrl = `${OTP}?nexturl=${encodeURIComponent(nextUrl)}`;
            //     return <Redirect to={otpUrl} />;
            // }
            return <Route {...rest} component={Content} />;
        }}
    />
);

export default PrivateRoute;
